import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SparklesIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsRow, SettingsToggleRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { notificationPrefs, type NotificationGroup } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
import { useSettings } from '../../contexts/SettingsContext';
const groups: NotificationGroup[] = ['health', 'progress', 'social', 'product'];
export function NotificationPreferences() {
  const {
    t,
    tl
  } = useLocale();
  const settings = useSettings();
  const navigate = useNavigate();
  return <div className="px-2 pb-2" data-id="element-3888" data-mp="hwfq84nb4j8x">
      <PageHeader title={t('settings.notifications')} subtitle={t('notifPrefs.subtitle')} showBack data-id="element-3889" data-mp="2ymntd6hzqbo0" />

      <Card className="p-2" data-id="element-3890" data-mp="32ohrb70sx1kh">
        <p className="text-[12px] leading-snug text-muted" data-id="element-3891" data-mp="32psv36u8y9bl">
          {t('notifPrefs.priority')}
        </p>
      </Card>

      <div className="mt-2" data-id="element-3892" data-mp="29nci02osf75k">
        <SettingsGroup data-id="element-3893" data-mp="24moq7esqimaa">
          <SettingsRow label={t('eng.rem.entry')} hint={t('eng.rem.entryHint')} icon={<SparklesIcon size={17} data-id="element-3895" data-mp="2imptt20dw7tg" />} onClick={() => navigate('/config/notificacoes/lembretes')} data-id="element-3894" data-mp="24n6umypjw6ta" />
        </SettingsGroup>
      </div>

      {groups.map(group => {
      const list = notificationPrefs.filter(pref => pref.group === group);
      const health = group === 'health';
      return <section key={group} className="mt-3" data-id="element-3896" data-mp="2niwykrh1nd9t">
            <SectionTitle data-id="element-3897" data-mp="32a70iu21nwge">{t(`notifPrefs.group.${group}`)}</SectionTitle>
            {health && <p className="-mt-1 mb-2 text-[11px] leading-snug text-gold-deep" data-id="element-3898" data-mp="2xakmwjib0e72">
                {t('notifPrefs.healthNote')}
              </p>}
            <div className={health ? 'rounded-card border border-gold/35' : ''} data-id="element-3899" data-mp="3b893hf5c8z6b">
              <SettingsGroup data-id="element-3900" data-mp="369fqdntyra6o">
                {list.map(pref => <SettingsToggleRow key={pref.id} label={tl(pref.label)} hint={pref.hint ? tl(pref.hint) : undefined} checked={settings.notifications[pref.id]} onChange={() => settings.toggleNotification(pref.id)} emphasis={health} data-id="element-3901" data-mp="23ze2mc1ue96n" />)}
              </SettingsGroup>
            </div>
          </section>;
    })}
    </div>;
}